import { Component, AfterViewInit, DoCheck, ViewChild, ElementRef, Output, EventEmitter, Input, OnChanges } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import * as encoding from 'encoding-japanese';
import { ShipCaseService } from '../../../service/ship-case/ship-case.service';
import { CommonService } from '../../../service/common/common.service';
import { environment } from '../../../../environments/environment';
import { isNumber } from '../../../util/util';
import { insertcomma } from '../../../util/util';
import { AgGridHelper } from '../../../util/AgGridHelper';
import { GridSelectRendererComponent } from '../../../render/grid-select-renderer.component';
import { config } from '../../../util/config';
import { forEach } from '@angular/router/src/utils/collection';

@Component({
  selector: 'wa3042',
  templateUrl: 'wa3042.component.html',
  styleUrls: ['wa3042.component.scss']
})
export class Wa3042Component implements AfterViewInit, DoCheck, OnChanges {
  private gridApi: any;
  public componentTitle = 'WA3042:出荷ケース一括修正';

  public carrierObj: any = {};
  // public commitObj: any = { 0: "", 1: "確定" };
  public ownerId: number;
  public cancelFl: number;
  public gridOptions: GridOptions;
  public rowData: any[];
  @Output()
  private onSubmitclick = new EventEmitter();
  @Input() isShow = false;
  private isDelayHide = true;
  private window;
  public working = false;
  public height = 500;
  public gridHeight = 450;
  public production = environment.production;
  public backgroundColor: string;
  public rowsPerPage = config.rowsPerPageSize;
  public rowsPerPageModel = [{ value: 10, viewValue: '10' }, { value: 20, viewValue: '20' }, { value: 100, viewValue: '100' }, { value: 500, viewValue: '500' }];
  public gridEditFl = [];

  private shipCaseData = null;
  private errorInfo = '';
  private openotherwindow: boolean = false;
  @ViewChild('gridView')
  private gridView: ElementRef;
  private gridHelper: AgGridHelper;
  private searchKeyKubun: any[];
  private dspnone: boolean = true;
  private paginationGetRowCount = 0;
  private paginationGetTotalPages = 0;
  private paginationGetCurrentPage = 0;
  private paginationGoToFirstPage;
  private paginationGoToNextPage;
  private isEnableClearFilter = null;
  private selectedCount = 0;
  private isSubmitButtonEnabled = false;
  private isEnableRightAreaButtons = false;
  private SHIPCASE_RANDOM_PROP_NAME = '__index';
  private carrierSelectObj = [];

  constructor(private router: Router, private builder: FormBuilder, private shipCaseService: ShipCaseService, private commonService: CommonService) {
    sessionStorage.removeItem('wa3042openwindow');
    const rows = localStorage.getItem('wa3042_rowsPerPage_idx');
    this.rowsPerPage = parseInt(rows, 10) || 10;
    this.gridHelper = new AgGridHelper();
    this.gridOptions = <GridOptions>{
      rowSelection: 'multiple',
      floatingFilter: true,
      enableRangeSelection: true,
      localeText: environment.gridLocale,
      getContextMenuItems: this.getContextMenuItems,
      onColumnResized: this.saveColumnWidth,
      pagination: true,
      paginationPageSize: this.rowsPerPage,
      singleClickEdit: true,
      onColumnMoved: () => {
        this.saveColumnOrder();
      },
      onGridReady: params => {
        this.gridApi = params;
        const columns = [];
        for (const column of params.columnApi.getAllDisplayedColumns()) {
          const idx = localStorage.getItem(`wa3042_${column.getColId()}_idx`);
          if (idx !== null) {
            columns.push({ idx: parseInt(idx, 10), column: column });
          }
        }
        columns.sort((a, b) => {
          return a.idx - b.idx;
        });
        for (let i = columns.length - 1; i >= 0; i--) {
          const column = columns[i];
          params.columnApi.moveColumn(column.column, column.idx);
        }
        this.gridHelper.onGridReady();
      },
      onFilterChanged: () => {
        this.errorInfo = '';
        this.isEnableClearFilter = this.gridOptions.api.isAnyFilterPresent();
        this.gridHelper.onGridFilterChanged();
      },
      onPaginationChanged: () => {
        this.paginationGetRowCount = this.gridOptions.api.paginationGetRowCount();
        this.paginationGetTotalPages = this.gridOptions.api.paginationGetTotalPages();
        this.paginationGetCurrentPage = this.gridOptions.api.paginationGetCurrentPage() + 1;
        this.gridHelper.renderScrollArrow();
        this.gridHelper.renderGridCheckboxImage();
      },
      onRowDataChanged: () => {
        this.errorInfo = '';
        this.gridHelper.onRowDataChanged();

        if (this.gridOptions.rowData && this.gridOptions.rowData.length > 0) this.gridHelper.isShowGridNoDataOverlay = false;
        else this.gridHelper.isShowGridNoDataOverlay = true;
        /*
        Observable.timer(100).subscribe(() => {
          this.searchByKey();
        });*/
      },
      overlayLoadingTemplate: this.gridHelper.TEMPLATE_GRID_LOADING,
      overlayNoRowsTemplate: this.gridHelper.TEMPLATE_GRID_NODATA,
      postProcessPopup: params => {
        this.errorInfo = '';
        this.gridHelper.fixedAgMenu();
      },
      onSortChanged: () => {
        this.errorInfo = '';
        this.gridHelper.renderGridCheckboxImage();
      },
      onSelectionChanged: () => {
        this.errorInfo = '';
        this.selectedCount = this.gridOptions.api.getSelectedRows().length;
        this.isEnableRightAreaButtons = this.selectedCount > 0;
      }
    };

    this.gridOptions.columnDefs = [
      {
        headerName: '出荷日',
        field: 'endShortDt',
        unSortIcon: true,
        suppressMenu: true,
        width: this.getColumnWidth('endShortDt', 120),
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '届先名',
        field: 'dtnameTx',
        width: this.getColumnWidth('dtnameTx', 140),
        cellClass: ['tl', 'cellclass'],
        unSortIcon: true,
        suppressMenu: true
      },
      {
        headerName: '配送方法',
        field: 'carrierCd',
        width: this.getColumnWidth('carrierTx', 160),
        unSortIcon: true,
        suppressMenu: true,
        cellEditor: 'select',
        cellClass: (params) => {

          return ['tr', 'cellclass'];
        },

        cellEditorParams: {
          values: this.extractValues(this.carrierObj)
        },
        valueFormatter: params => {
          return this.lookupValue(this.carrierObj, params.value);
        },
        valueParser: params => {
          return this.lookupKey(this.carrierObj, params.newValue);
        },
        cellRendererFramework: GridSelectRendererComponent,
        cellRendererParams: {
          dataSource: this.carrierSelectObj,
          field: 'carrierCd',
          onSelectChanged: this.onGridSelectChanged.bind(this),
          cellClass: this.gridCellClass.bind(this)
        }
      },
      {
        headerName: '問合せNo',
        field: 'reqnoCd',
        cellStyle: { backgroundColor: 'rgb(247, 252, 205)', border: '1px solid #ccc' },
        width: this.getColumnWidth('reqnoCd', 150),
        editable: true,
        cellClass: (params) => {
          return this.inputCellClass(params, 'reqnoCd');
        }
      },
      {
        headerName: '出荷個口数',
        field: 'shipcaseNr',
        cellStyle: { backgroundColor: 'rgb(247, 252, 205)', border: '1px solid #ccc' },
        width: this.getColumnWidth('shipcaseNr', 100),
        editable: true,
        cellEditor: 'numericCellEditor',
        cellClass: (params) => {
          return this.inputCellClass(params, 'shipcaseNr');
        },
        onCellValueChanged: params => {
          this.gridEditFl[params.node.childIndex] = true;
        }
      },
      {
        headerName: '単価',
        field: 'deliunitpriceNr',
        cellStyle: { backgroundColor: 'rgb(247, 252, 205)', border: '1px solid #ccc' },
        width: this.getColumnWidth('deliunitpriceNr', 100),
        editable: true,
        cellEditor: 'numericCellEditor',
        cellClass: (params) => {
          return this.inputCellClass(params, 'deliunitpriceNr');
        },
        valueFormatter: insertcomma,
        onCellValueChanged: params => {
          this.gridEditFl[params.node.childIndex] = true;
        }
      },
      {
        headerName: '金額',
        field: 'delipriceNr',
        cellStyle: { backgroundColor: 'rgb(247, 252, 205)', border: '1px solid #ccc' },
        width: this.getColumnWidth('delipriceNr', 100),
        cellClass: (params) => {
          return this.inputCellClass(params, 'delipriceNr');
        },
        valueFormatter: insertcomma,
        valueGetter: params => {
          if (this.gridEditFl[params.node.childIndex] == true) {
            params.data.delipriceNr = params.data.shipcaseNr * params.data.deliunitpriceNr;
          }
          return params.data.delipriceNr;
        },
        editable: true,
        onCellValueChanged: params => {
          this.gridEditFl[params.node.childIndex] = false;
        }
      },
      {
        headerName: '備考',
        headerTooltip: '備考',
        field: 'delichargememoTx',
        cellStyle: { backgroundColor: 'rgb(247, 252, 205)', border: '1px solid #ccc' },
        width: this.getColumnWidth('delichargememoTx', 300),
        editable: true,
        cellClass: (params) => {
          return this.inputCellClass(params, 'delichargememoTx');
        }
      }
    ];

    this.height = window.innerHeight - 80;
    this.setGridHeight();
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
    this.searchKeyKubun = [];
    this.gridHelper.setGridOptions(this.gridOptions);
    this.gridHelper.onViewportScrollListener = () => {
      this.fixedDateFilterInput();
    };

    this.ownerId = Number(sessionStorage.getItem('wa3042_ownerId'));
  }

  fixedDateFilterInput() {
    var dateFilter = this.gridView.nativeElement.querySelector('.ag-filter-filter');
    if (dateFilter == null) return;
    dateFilter.classList.add('ag-floating-filter-input');
    dateFilter.placeholder = '';
  }

  getColumnWidth(id: string, def: number): number {
    return parseInt(localStorage.getItem(`wa3042_${id}_width`), 10) || def;
  }

  saveColumnWidth(params) {
    if (params.finished === true && params.type === 'columnResized') {
      localStorage.setItem(`wa3042_${params.column.colId}_width`, params.column.actualWidth);
    }
  }

  saveColumnOrder() {
    let idx = 0;
    for (const column of this.gridApi.columnApi.getAllDisplayedColumns()) {
      if (column.colId !== '0') {
        localStorage.setItem(`wa3042_${column.colId}_idx`, `${idx}`);
      }
      idx++;
    }
  }

  paginatorRowChange() {
    this.gridOptions.api.paginationSetPageSize(this.rowsPerPage);
    localStorage.setItem('wa3042_rowsPerPage_idx', `${this.rowsPerPage}`);
    this.setGridHeight();
  }
  setGridHeight() {
    if (this.rowsPerPage === 10) {
      this.gridHeight = window.innerHeight - 270;
    } else {
      this.gridHeight = window.innerHeight - 170;
    }
  }

  getContextMenuItems(params) {
    const str_to_unicode_array = str => {
      const arr = [];
      for (let i = 0; i < str.length; i++) {
        arr.push(str.charCodeAt(i));
      }
      return arr;
    };

    const download = csvString => {
      // Unicode コードポイントの配列に変換する
      const unicode_array = str_to_unicode_array(csvString);
      // S-JIS コードポイントの配列に変換
      const sjis_code_array = encoding.convert(
        unicode_array, // ※文字列を直接渡すのではない点に注意
        'SJIS', // to
        'UNICODE' // from
      );
      // 文字コード配列をTypedArrayに変換する
      const uint8_array = new Uint8Array(sjis_code_array);
      // 指定されたデータを保持するBlobを作成する
      const blob = new Blob([uint8_array], { type: 'text/csv' });
      // Internet Explorer
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, 'export.csv');
      } else {
        // Chrome
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = 'export.csv';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    };

    const result = [
      'copy',
      'copyWithHeaders',
      'separator',
      {
        name: 'エクスポート',
        subMenu: [
          {
            name: 'チェックした行をCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv({ onlySelected: true }));
            }
          },
          {
            name: 'すべてCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv());
            }
          },
          'excelExport'
        ]
      }
    ];

    return result;
  }

  ngAfterViewInit() {
    this.gridHelper.el = this.gridView;
    setTimeout(() => {
      this.onSubmit();
    }, 1000);
  }

  onFilterClear() {
    this.gridOptions.api.setFilterModel(null);
  }

  onSubmit() {
    this.shipCaseService
      .post(JSON.stringify({"ownerId": this.ownerId}))
      .then(outputJson => {
        // var i = outputJson.shipcases.length;
        // while (i--) {
        //   if (outputJson.shipcases[i].commitFl == 1 || outputJson.shipcases[i].stshipcaseId != 0) {
        //     outputJson.shipcases.splice(i, 1);
        //   }
        // }

        if (outputJson.shipcases != null && outputJson.shipcases.length > 0) {
          var i = 0;
          outputJson.shipcases.forEach(v => {
            v[this.SHIPCASE_RANDOM_PROP_NAME] = i;
            i++;
          });
        }
        this.rowData = outputJson.shipcases;

        this.shipCaseData = [];
        outputJson.shipcases.forEach(item => {
          var tmp = {};
          for (var k in item)
            tmp[k] = item[k]
          this.shipCaseData.push(tmp);
        });
        if (this.rowData.length == 0) {
          this.errorInfo = '未確定のデータがありません';
          sessionStorage.removeItem('wa3042_ownerId');
          return;
        }
      })
      .catch(error => {
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  extractValues(mappings) {
    return Object.keys(mappings).map(k => {
      return mappings[k];
    });
  }

  lookupValue(mappings, key) {
    return mappings[key];
  }

  lookupKey(mappings, name) {
    for (var key in mappings) {
      if (mappings.hasOwnProperty(key)) {
        if (name === mappings[key]) {
          return key;
        }
      }
    }
  }

  execute() {
    this.errorInfo = '';
    //SW-2097　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    var status = [];
    var tmpErrorInfo = '';

    for (let i = 0; i < this.rowData.length; i++) {
      let rowNum = this.rowData.length - i;

      if (this.rowData[i].reqnoCd.length > 20) {
        this.working = false;
        this.errorInfo = rowNum + '行目：問合せNoは20文字以下で入力してください';
        return;
      }
      if (!this.rowData[i].shipcaseNr) {
        this.working = false;
        this.errorInfo = rowNum + '行目：出荷個口数は必須です';
        return;
      }
      if (!isNumber(this.rowData[i].shipcaseNr) || this.rowData[i].shipcaseNr > 9999999 || this.rowData[i].shipcaseNr < 0) {
        this.working = false;
        this.errorInfo = rowNum + '行目：出荷個口数は1~9999999の間の数字で入力してください';
        return;
      }
      /*
      if (!this.rowData[i].deliunitpriceNr && this.rowData[i].deliunitpriceNr != 0) {
        this.working = false;
        this.errorInfo = rowNum + '行目：単価は必須です。';
        return;
      }
      */
      if (!isNumber(this.rowData[i].deliunitpriceNr)) {
        console.log('deliunitpriceNr:[' + String(this.rowData[i].deliunitpriceNr) + ']');
        console.log(this.rowData[i]);
        this.working = false;
        this.errorInfo = rowNum + '行目：単価は半角数字で入力してください';
        return;
      }
      if (this.rowData[i].deliunitpriceNr > 9999999 || this.rowData[i].deliunitpriceNr < 0) {
        this.working = false;
        this.errorInfo = rowNum + '行目：単価は0~9999999より小さい数字で入力してください';
        return;
      }
      if (this.rowData[i].delichargememoTx && this.rowData[i].delichargememoTx.length > 50) {
        this.working = false;
        this.errorInfo = rowNum + '行目：備考は50文字以下で入力してください';
        return;
      }
      if (!this.rowData[i].delipriceNr && this.rowData[i].delipriceNr != 0) {
        console.log('delipriceNr:[' + String(this.rowData[i].delipriceNr) + ']');
        console.log(this.rowData[i]);
        this.working = false;
        this.errorInfo = rowNum + '行目：金額は必須です。';
        return;
      }
      if (!isNumber(this.rowData[i].delipriceNr) || this.rowData[i].delipriceNr > 9999999 || this.rowData[i].delipriceNr < 0) {
        console.log('delipriceNr:[' + String(this.rowData[i].delipriceNr) + ']');
        console.log(this.rowData[i]);
        this.working = false;
        this.errorInfo = rowNum + '行目：金額は0~9999999の半角数字で入力してください';
        return;
      }
    }

    for (let i = 0; i < this.rowData.length; i++) {
      this.shipCaseService
        .put(
          this.rowData[i].shipcaseId,
          this.rowData[i].shipcaseNr,
          this.rowData[i].carrierCd,
          this.rowData[i].reqnoCd,
          this.rowData[i].deliunitpriceNr,
          this.rowData[i].delipriceNr,
          this.rowData[i].delichargememoTx,
          this.rowData[i].cancelFl,
          this.rowData[i].notinvoiceFl,
          'wa3042'
        )
        .then(outputJson => {
          status.push(true);
          if (i == this.rowData.length - 1) {
            this.errorInfo = tmpErrorInfo;
            this.working = false;
            var isSuccess = true;
            status.forEach(v => {
              if (!v)
                isSuccess = v;
            });
            if (isSuccess) {
              sessionStorage.removeItem('wa3042openwindow');
              sessionStorage.removeItem('wa3042_ownerId');
              this.onSubmitclick.emit(true);
              sessionStorage.removeItem('isOwnerDisable');
            }
          }
        })
        .catch(error => {
          this.working = false;
          console.log(this.commonService.getErrorMessage(error));
          tmpErrorInfo = this.commonService.getErrorMessage(error);
          status.push(false);
        });
    }
  }

  ngDoCheck() {
    if (!this.isShow)
      return;

    if (this.rowData == null || this.rowData.length == 0)
      return;


    var upd = true;

    for (let i = 0; i < this.rowData.length; i++) {
      let rowNum = this.rowData.length - i;
      var shipCase = this.shipCaseData[i];
      if (shipCase.carrierCd !== this.rowData[i].carrierCd) {
        this.isSubmitButtonEnabled = true;
        return;
      } else
        upd = false;

      if (shipCase.reqnoCd !== this.rowData[i].reqnoCd) {
        this.isSubmitButtonEnabled = true;
        return;
      } else
        upd = false;

      if (shipCase.shipcaseNr !== this.rowData[i].shipcaseNr) {
        this.isSubmitButtonEnabled = true;
        return;
      } else
        upd = false;

      if (shipCase.deliunitpriceNr !== this.rowData[i].deliunitpriceNr) {
        this.isSubmitButtonEnabled = true;
        return;
      } else
        upd = false;

      if (shipCase.delichargememoTx !== this.rowData[i].delichargememoTx) {
        this.isSubmitButtonEnabled = true;
        return;
      } else
        upd = false;

      if (shipCase.delipriceNr !== this.rowData[i].delipriceNr) {
        this.isSubmitButtonEnabled = true;
        return;
      } else
        upd = false;

    }

    if (this.isSubmitButtonEnabled != upd)
      this.errorInfo = '';

    this.isSubmitButtonEnabled = upd;

  }

  dsp() {
    setTimeout(() => {
      this.dspnone = true;
    }, 1000);
  }

  cancel() {
    sessionStorage.removeItem('wa3042openwindow');
    sessionStorage.removeItem('wa3042_ownerId');
    this.onSubmitclick.emit(true);
    sessionStorage.removeItem('isOwnerDisable');
    this.errorInfo = '';
  }

  onGridSelectChanged(node, selectedValue) {
    this.rowData[node.id].carrierCd = selectedValue;
  }

  gridCellClass(node, selectedValue) {
    if (this.shipCaseData != null) {
      //for (let i = 0; i < this.shipCaseData.length; i++) {
      var shipCase = this.shipCaseData[node.rowIndex];
      if (selectedValue !== shipCase.carrierCd) {
        return ['tr', 'cellclass', 'active'];
      }
      //}
    }
    return ['tr', 'cellclass'];
  }

  renderDropSelectComponent() {
    this.carrierSelectObj = [];
    this.carrierSelectObj.push({
      name: '配送会社を選択してください。',
      value: ''
    });

    for (let carrierKey in this.carrierObj) {
      this.carrierSelectObj.push({
        name: this.carrierObj[carrierKey],
        value: carrierKey
      });
    }

    this.gridOptions.columnApi.getColumn('carrierCd').getColDef().cellRendererParams.dataSource = this.carrierSelectObj;
    this.gridOptions.api.refreshCells({
      columns: ['carrierCd'],
      force: true
    });
  }

  ngOnChanges() {
    if (this.isShow) {
      this.isDelayHide = false;
      this.errorInfo = '';
      this.isSubmitButtonEnabled = false;
      this.carrierObj = JSON.parse(sessionStorage.getItem('carrierObj'));
      this.ownerId = Number(sessionStorage.getItem('wa3042_ownerId'));
      this.renderDropSelectComponent();

      setTimeout(() => {
        this.onSubmit();
      }, 200);
    } else {
      setTimeout(() => {
        this.isDelayHide = true;
      }, 300);
    }
    // if (this.window) {
    //   this.carrierObj = JSON.parse(sessionStorage.getItem('carrierObj'));
    //   this.ownerId = Number(sessionStorage.getItem('wa3042_ownerId'));
    //   this.isSubmitButtonEnabled = false;
    //   this.onSubmit();
    // }
  }

  inputCellClass(params, field) {
    if (this.shipCaseData != null) {
      for (let i = 0; i < this.shipCaseData.length; i++) {
        if (this.shipCaseData[i][this.SHIPCASE_RANDOM_PROP_NAME] == params.data[this.SHIPCASE_RANDOM_PROP_NAME]) {
          var cls = null;
          if (params.value != this.shipCaseData[i][field]) {
            cls = 'txtactive';
          }
          return this._inputCellClass(params, cls);
        }
      }
    }
    return this._inputCellClass(params, null);
  }
  _inputCellClass(params, cls) {
    var defaultClss = ['tr', 'cellclass', 'editClass', 'noCellFocus'];
    if (cls == null) {
      var rowDOM = this.gridView.nativeElement.querySelectorAll('div[role="row"]');

      if (rowDOM != null) {
        rowDOM.forEach(item => {

          if (!item.hasAttribute('row'))
            return;
          var rowValue = item.getAttribute('row');
          if (rowValue !== params.node.id)
            return;

          var cells = item.querySelectorAll('.ag-cell[role="gridcell"][colId="' + params.colDef.field + '"]');//
          if (cells.length == 0)
            return;

          if (cells[0].classList.contains('txtactive'))
            cells[0].classList.remove('txtactive');
        });
      }
      return defaultClss;
    }
    defaultClss.push(cls);
    return defaultClss;
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa3Shipment/wa3042/wa3042.component.ts